import styled from 'styled-components'
import {TextField} from '@material-ui/core'

export const StyledTextField = styled(TextField)`
  width: ${props => props.width || '200px'};
`
